/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInConnectRequestIntent } from './linkedInConnectRequestIntent';

/**
 * Per spec §6b — direct credential proxy. Backend forwards to Unipile
 * inside the same request and never persists the password.
 */
export interface LinkedInConnectRequest {
  username: string;
  /**
     * @minLength 1
     * @maxLength 255
     */
  password: string;
  intent?: LinkedInConnectRequestIntent;
}
